import { render, staticRenderFns } from "./othersProduct.vue?vue&type=template&id=7495c71a&scoped=true&"
import script from "./othersProduct.vue?vue&type=script&lang=js&"
export * from "./othersProduct.vue?vue&type=script&lang=js&"
import style0 from "./othersProduct.vue?vue&type=style&index=0&id=7495c71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495c71a",
  null
  
)

export default component.exports